import React, {useMemo} from "react";
import {Link, useTranslation} from "gatsby-plugin-react-i18next";
import {ArrowRight} from "@phosphor-icons/react";
import DemoPanel from "./demo-panel";
import SectionHeading from "./section-heading";
import {sklep, hotel, wsparcie, SCENE_TINTS} from "./demo-scenarios";

const Examples = () => {
    const {t, i18n} = useTranslation();

    const scenariuszSklep = useMemo(() => sklep(t), [t, i18n.language]);
    const scenariuszHotel = useMemo(() => hotel(t), [t, i18n.language]);
    const scenariuszWsparcie = useMemo(() => wsparcie(t), [t, i18n.language]);

    const DEMA = [
        {klucz: "sklep", eyebrow: t("In an online store"), tytul: t("Advises and sells"), scenario: scenariuszSklep, tint: SCENE_TINTS.shop,
         opis: t("Understands a described need, searches your catalogue, shows product cards and checks order status."),
         cta: t("See the offer for stores"), to: "/industry/ecommerce/"},
        {klucz: "hotel", eyebrow: t("In a hotel"), tytul: t("Answers and books"), scenario: scenariuszHotel, tint: SCENE_TINTS.hotel,
         opis: t("Answers about availability, rates and stay conditions in the guest's language, and steers to a direct booking."),
         cta: t("See the offer for hotels"), to: "/industry/hospitality/"},
        {klucz: "wsparcie", eyebrow: t("In customer service"), tytul: t("Solves and hands over"), scenario: scenariuszWsparcie, tint: SCENE_TINTS.support,
         opis: t("Checks the order, fixes what it can and hands the rest to your team with the whole conversation attached."),
         cta: t("See all features"), to: "/features/"},
    ];

    return (
        <section className="w-full max-w-screen-2xl mx-auto px-5">
            <SectionHeading
                className="mb-10"
                eyebrow={t("Live, not a screenshot")}
                title={t("This is the agent talking.|The same widget your customers get.")}
            />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-[var(--cl-rule)] border border-[var(--cl-rule)]">
                {DEMA.map((d) => (
                    <div key={d.klucz} className="bg-[var(--cl-surface)] p-6 sm:p-8 flex flex-col gap-5">
                        <div className="flex flex-col gap-2">
                            <span className="cl-eyebrow">{d.eyebrow}</span>
                            <h3 className="text-xl font-bold text-[var(--cl-ink)]">{d.tytul}</h3>
                            <p className="text-base leading-relaxed text-[var(--cl-ink-2)] max-w-[44ch] lg:min-h-[5.25rem]">
                                {d.opis}
                            </p>
                        </div>

                        <DemoPanel scenario={d.scenario} tint={d.tint} height={540}/>

                        <Link to={d.to}
                              className="inline-flex items-center gap-2 text-base font-semibold text-[var(--cl-ink)] hover:underline">
                            {d.cta}
                            <ArrowRight size={16} weight="bold"/>
                        </Link>
                    </div>
                ))}
            </div>

            <p className="mt-5 text-[13px] text-[var(--cl-muted)]">
                {t("Recorded conversations, played back in the real widget. Want to talk to a live one? It is waiting in the corner of this page.")}
            </p>
        </section>
    );
};

export default Examples;
